module.exports = __webpack_public_path__ + "static/media/500031.afe3941b.svg";